/**
 * For asynchronous functions, pauses execution for `ms` milliseconds.
 * @example
 * async speak() {
 *   console.log("Hi");
 *   await sleep(1000);
 *   console.log("Uh..."); // 1 second later
 * }
 */
export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * @returns A value rounded to a number of decimals.
 * @example roundTo(123.456, 2) // 123.46
 */
export function roundTo(value: number, decimalCount: number) {
  const pow = Math.pow(10, decimalCount);
  return Math.round(value * pow) / pow;
}

/**
 * Formats strings. Example: "test testsson" => "Test Testsson".
 * @param str String to format.
 * @returns A completed string where every word's first letter is capitalized.
 */
export function formatName(str: string) {
  if (!str) {
    return str;
  }

  const words = str.split(" ");

  return words.map(word => {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  }).join(" ");
}